export default "__VITE_ASSET__DbtNJ7N___"